import {
  addUniqueValueToArray,
  sortArrayWithPositions
} from 'utils/redux'
import { INIT } from './view'

export const NAMESPACE = 'KanBo/Card/elements/'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const SET = NAMESPACE + 'SET'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_POSITION = NAMESPACE + 'SET_POSITION'
export const SET_POSITIONS = NAMESPACE + 'SET_POSITIONS'
export const SET_NAME = NAMESPACE + 'SET_NAME'
export const SET_CONTENT = NAMESPACE + 'SET_CONTENT'
export const ADD_ITEM = NAMESPACE + 'ADD_ITEM'
export const REMOVE_ITEM = NAMESPACE + 'REMOVE_ITEM'
export const POSITION_ITEM = NAMESPACE + 'POSITION_ITEM'
export const POSITION_ITEMS = NAMESPACE + 'POSITION_ITEMS'

const defaultCardState = {
  elements: []
}

const initialState = {
  elementsById: {}
}

const elementDefaults = {
  name: ''
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        [action.payload.cardId]: {
          ...defaultCardState,
        }
      }
    case ADD:
      return state[action.payload.cardId] ? {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          elements: addUniqueValueToArray({
            array: state[action.payload.cardId].elements,
            value: action.payload.element.id,
            index: action.payload.index
          }),
        },
        elementsById: {
          ...state.elementsById,
          [action.payload.element.id]: {
            ...elementDefaults,
            ...state.elementsById[action.payload.element.id],
            ...action.payload.element
          }
        }
      } : state
    case ADD_ARRAY: {
      if (!state[action.payload.cardId]) return state

      const newState = {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          elements: [ ...state[action.payload.cardId].elements ]
        },
        elementsById: { ...state.elementsById },
      }

      action.payload.array.forEach(element => {
        newState[action.payload.cardId].elements = addUniqueValueToArray({
          array: newState[action.payload.cardId].elements,
          value: element.id,
          index: element.index
        })
        newState.elementsById[element.id] = {
          ...elementDefaults,
          ...newState.elementsById[element.id],
          ...element
        }
      })

      return newState
    }
    case SET:
      return (state[action.payload.cardId] && state.elementsById[action.payload.element.id]) ? {
        ...state,
        elementsById: {
          ...state.elementsById,
          [action.payload.element.id]: {
            ...elementDefaults,
            ...state.elementsById[action.payload.element.id],
            ...action.payload.element
          }
        }
      } : state
    case REMOVE: {
      if (!state[action.payload.cardId]) return state

      const newState = {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          elements: [ ...state[action.payload.cardId].elements.filter(id => id !== action.payload.elementId) ],
        }
      }

      return newState
    }
    case SET_POSITION:
      return state[action.payload.cardId] ? {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          elements: addUniqueValueToArray({
            array: state[action.payload.cardId].elements,
            value: action.payload.elementId,
            index: action.payload.index
          })
        },
      } : state
    case SET_POSITIONS:
      return state[action.payload.cardId] ? {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          elements: sortArrayWithPositions(state[action.payload.cardId].elements, action.payload.positionsById)
        },
      } : state
    case SET_NAME:
      return state.elementsById[action.payload.elementId] ? {
        ...state,
        elementsById: {
          ...state.elementsById,
          [action.payload.elementId]: {
            ...state.elementsById[action.payload.elementId],
            name: action.payload.name
          }
        }
      } : state
    case SET_CONTENT:
      return state.elementsById[action.payload.elementId] ? {
        ...state,
        elementsById: {
          ...state.elementsById,
          [action.payload.elementId]: {
            ...state.elementsById[action.payload.elementId],
            content: action.payload.content
          }
        }
      } : state
    case ADD_ITEM:
      return state.elementsById[action.payload.elementId] ? {
        ...state,
        elementsById: {
          ...state.elementsById,
          [action.payload.elementId]: {
            ...state.elementsById[action.payload.elementId],
            items: addUniqueValueToArray({
              array: state.elementsById[action.payload.elementId].items,
              value: action.payload.itemId,
              index: action.payload.index
            })
          }
        }
      } : state
    case REMOVE_ITEM:
      return (state.elementsById[action.payload.elementId] && state.elementsById[action.payload.elementId].items.indexOf(action.payload.itemId) !== -1) ? {
        ...state,
        elementsById: {
          ...state.elementsById,
          [action.payload.elementId]: {
            ...state.elementsById[action.payload.elementId],
            items: state.elementsById[action.payload.elementId].items.filter(itemId => itemId !== action.payload.itemId)
          }
        }
      } : state
    case POSITION_ITEM:
      return (state.elementsById[action.payload.elementId] && state.elementsById[action.payload.elementId].items.indexOf(action.payload.itemId) !== -1) ? {
        ...state,
        elementsById: {
          ...state.elementsById,
          [action.payload.elementId]: {
            ...state.elementsById[action.payload.elementId],
            items: addUniqueValueToArray({
              array: state.elementsById[action.payload.elementId].items,
              value: action.payload.itemId,
              index: action.payload.index
            })
          }
        }
      } : state
    case POSITION_ITEMS:
      return state.elementsById[action.payload.elementId] ? {
        ...state,
        elementsById: {
          ...state.elementsById,
          [action.payload.elementId]: {
            ...state.elementsById[action.payload.elementId],
            items: sortArrayWithPositions(
              state.elementsById[action.payload.elementId].items,
              action.payload.positionsById
            )
          }
        }
      } : state
    default: return state
  }
}

export function add ({ cardId, element }) {
  return {
    type: ADD,
    payload: {
      cardId,
      element
    }
  }
}

export function addArray ({ cardId, array }) {
  return {
    type: ADD_ARRAY,
    payload: {
      cardId,
      array
    }
  }
}

export function set ({ cardId, element }) {
  return {
    type: SET,
    payload: {
      cardId,
      element
    }
  }
}

export function remove ({ cardId, elementId }) {
  return {
    type: REMOVE,
    payload: {
      cardId,
      elementId
    }
  }
}

export function setPosition ({ cardId, elementId, index }) {
  return {
    type: SET_POSITION,
    payload: {
      cardId,
      elementId,
      index
    }
  }
}

export function setPositions ({ cardId, positionsById }) {
  return {
    type: SET_POSITIONS,
    payload: {
      cardId,
      positionsById
    }
  }
}

export function setName ({ elementId, name }) {
  return {
    type: SET_NAME,
    payload: {
      elementId,
      name
    }
  }
}

export function setContent ({ elementId, content }) {
  return {
    type: SET_CONTENT,
    payload: {
      elementId,
      content
    }
  }
}

export function addItem ({ elementId, itemId, index }) {
  return {
    type: ADD_ITEM,
    payload: {
      elementId,
      itemId,
      index
    }
  }
}

export function removeItem ({ elementId, itemId }) {
  return {
    type: REMOVE_ITEM,
    payload: {
      elementId,
      itemId
    }
  }
}

export function positionItem ({ elementId, itemId, index }) {
  return {
    type: POSITION_ITEM,
    payload: {
      elementId,
      itemId,
      index
    }
  }
}

export function positionItems ({ elementId, positionsById }) {
  return {
    type: POSITION_ITEMS,
    payload: {
      elementId,
      positionsById
    }
  }
}
